export default function queryConverter(queryOptions: APIRequest.Query | undefined): string {
  let queryStr = '';
  if (queryOptions instanceof URLSearchParams) {
    queryStr = queryOptions.toString();
  } else if (typeof queryOptions === 'string') {
    queryStr = queryOptions;
  }
  return queryStr;
}
